import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillingCreditCardGeneric = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 48,
	viewBox: "0 0 72 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_657_87386)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37258 5.37258 0 12 0H59.4419C66.0693 0 71.4419 5.37258 71.4419 12V36C71.4419 42.6274 66.0693 48 59.4419 48H12C5.37258 48 0 42.6274 0 36V12Z",
			fill: "#BF9200"
		}), /* @__PURE__ */ _jsx("rect", {
			y: 7.81396,
			width: 71.4419,
			height: 10.0465,
			fill: "#604900"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_657_87386",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37258 5.37258 0 12 0H59.4419C66.0693 0 71.4419 5.37258 71.4419 12V36C71.4419 42.6274 66.0693 48 59.4419 48H12C5.37258 48 0 42.6274 0 36V12Z",
			fill: "white"
		})
	}) })]
});
export default SvgBillingCreditCardGeneric;
